import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { DialogDescription } from "@radix-ui/react-dialog";

const PolicyLink = ({
	name,
	href,
	className,
}: {
	name: React.ReactNode;
	href: string;
	external?: boolean;
	className?: string;
}) => {
	return (
		<Dialog>
			<DialogTrigger asChild>
				<Label
					className={cn(
						"iubenda-link iubenda-iframe-embed cursor-pointer",
						className,
					)}
				>
					{name}
				</Label>
			</DialogTrigger>
			<DialogContent className="max-w-7xl p-0">
				<DialogHeader className="sr-only">
					<DialogTitle>{name}</DialogTitle>
					<DialogDescription>Link to {href}</DialogDescription>
				</DialogHeader>
				<iframe
					src={href}
					title={name as string}
					className="h-[80vh] w-full rounded-lg"
				/>
			</DialogContent>
		</Dialog>
	);
};

export default PolicyLink;
